import { Group, Section } from '../../components/types';

interface UseSectionsManagementProps {
  groups: Group[];
  setGroups: (groups: Group[]) => void;
  saveToHistory: () => void;
  generateId: () => string;
}

export function useSectionsManagement({
  groups,
  setGroups,
  saveToHistory,
  generateId,
}: UseSectionsManagementProps) {
  const addSection = (groupId: string, insertIndex?: number) => {
    saveToHistory();
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          const newSection: Section = {
            id: generateId(),
            name: 'Nova Seção',
            order: insertIndex !== undefined ? insertIndex : group.sections.length,
            questions: [],
          };

          let updatedSections: Section[];
          if (insertIndex !== undefined) {
            updatedSections = [...group.sections];
            updatedSections.splice(insertIndex, 0, newSection);
            updatedSections = updatedSections.map((s, idx) => ({ ...s, order: idx }));
          } else {
            updatedSections = [...group.sections, newSection];
          }

          return { ...group, sections: updatedSections };
        }
        return group;
      })
    );
  };

  const editSection = (groupId: string, sectionId: string, name: string) => {
    saveToHistory();
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          return {
            ...group,
            sections: group.sections.map((section) =>
              section.id === sectionId ? { ...section, name } : section
            ),
          };
        }
        return group;
      })
    );
  };

  const removeSection = (groupId: string, sectionId: string) => {
    saveToHistory();
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          const filteredSections = group.sections.filter((section) => section.id !== sectionId);
          return {
            ...group,
            sections: filteredSections.map((section, index) => ({
              ...section,
              order: index,
            })),
          };
        }
        return group;
      })
    );
  };

  const duplicateSection = (groupId: string, sectionId: string) => {
    saveToHistory();
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          const sectionToDuplicate = group.sections.find((s) => s.id === sectionId);
          if (!sectionToDuplicate) return group;

          const duplicatedSection: Section = {
            ...JSON.parse(JSON.stringify(sectionToDuplicate)),
            id: generateId(),
            name: `${sectionToDuplicate.name} (Cópia)`,
            order: group.sections.length,
            questions: sectionToDuplicate.questions.map((question, index) => ({
              ...question,
              id: generateId(),
              order: index,
            })),
          };

          return {
            ...group,
            sections: [...group.sections, duplicatedSection],
          };
        }
        return group;
      })
    );
  };

  return {
    addSection,
    editSection,
    removeSection,
    duplicateSection,
  };
}
